import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 sign_in_auth: { message: "idle" },
};

export const sign_in_auth_Slice = createSlice({
 name: "sign_in_auth",
 initialState,
 reducers: {
  success_sign_in_auth: (state, action) => {
   state.sign_in_auth = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_sign_in_auth: (state, action) => {
   state.sign_in_auth = { status: app_consts.FAIL, message: action.payload };
  },
  reset_sign_in_auth: (state) => {
   state.sign_in_auth = { status: app_consts.IDLE };
  },
  loading_sign_in_auth: (state) => {
   state.sign_in_auth = { status: app_consts.LOADING };
  },
 }
});

export const { success_sign_in_auth, fail_sign_in_auth, reset_sign_in_auth, loading_sign_in_auth } = sign_in_auth_Slice.actions;

export default sign_in_auth_Slice.reducer;